const postAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Post URL',
    value: 'url',
    legendText: 'Post URL'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made '
  },
  {
    text: 'Accounts Reached',
    value: 'reach',
    legendText: 'The total number of unique users who viewed the content'
  },
  {
    text: 'Impressions',
    value: 'impressions',
    legendText: `The total number of times the content is displayed on an user's feed`
  },
  {
    text: 'Likes',
    value: 'likes',
    legendText: 'The number of times users have tapped the “like” button on a post.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a post.'
  },
  {
    text: 'Comments',
    value: 'comments',
    legendText: 'The number of written responses to a post.'
  },
  {
    text: 'Saves',
    value: 'saved',
    legendText: 'The number of times users have saved a post to their “Saved” folder.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  },
  {
    text: 'Views',
    value: 'views',
    legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
  },
  {
    text: 'Engagement Rate by Outreach',
    value: 'new_engagement_rate',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by the outreach numbers'
  },
  {
    text: 'Play Rate (by Outreach)',
    value: 'new_engagement_rate_view',
    legendText: 'The total number of views divided by the outreach numbers'
  },
  {
    text: 'Engagement Rate by Reach',
    value: 'engagement_rate_reach',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
  },
  {
    text: 'Avg. Engagement Rate',
    value: 'engagement_rate_sd',
    legendText: 'The average sum of engagement rate on the last 30 posts'
  },
  {
    text: 'Median Engagement Rate',
    value: 'median_engagement_rate',
    legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
  },
  {
    text: 'Average Likes',
    value: 'avg_likes',
    legendText: 'Average likes over the last 30 posts'
  },
  {
    text: 'Average Comments',
    value: 'avg_comments',
    legendText: 'Average comments over the last 30 posts'
  },
  {
    text: 'Average Views',
    value: 'avg_views',
    legendText: 'Average views over the last 30 posts'
  }
]
const storyAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made '
  },
  {
    text: 'Accounts Reached',
    value: 'reach',
    legendText: 'The total number of unique users who viewed the content'
  },
  {
    text: 'Impressions',
    value: 'impressions',
    legendText: `The total number of times the content is displayed on an user's feed`
  },
  {
    text: 'Replies',
    value: 'replies',
    legendText: 'The number of replies to a story.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a story.'
  },
  {
    text: 'Links Click',
    value: 'link_clicks',
    legendText: 'The number of times users have tapped the link attached on a story.'
  },
  {
    text: 'Sticker Taps',
    value: 'sticker_taps',
    legendText: 'The number of times users have tapped the hashtags and mentions attached on a story.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  },
  {
    text: 'Average Views',
    value: 'avg_views',
    legendText: 'Average views over the last 30 posts'
  },
  {
    text: 'Average Reels Plays',
    value: 'avg_reels_plays',
    legendText: 'Average plays over the last 30 posts'
  }
]
const reelAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Post URL',
    value: 'url',
    legendText: 'Post URL'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made '
  },
  {
    text: 'Accounts Reached',
    value: 'reach',
    legendText: 'The total number of unique users who viewed the content'
  },
  {
    text: 'Impressions',
    value: 'impressions',
    legendText: `The total number of times the content is displayed on an user's feed`
  },
  {
    text: 'Likes',
    value: 'likes',
    legendText: 'The number of times users have tapped the “like” button on a post.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a post.'
  },
  {
    text: 'Comments',
    value: 'comments',
    legendText: 'The number of written responses to a post.'
  },
  {
    text: 'Saves',
    value: 'saved',
    legendText: 'The number of times users have saved a post to their “Saved” folder.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  },
  {
    text: 'Plays',
    value: 'views',
    legendText: 'The number of times users have viewed a video for 3 seconds or more, not inclusive of looped views.'
  },
  {
    text: 'Watch Time',
    value: 'plays',
    legendText: `The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.`
  },
  {
    text: 'Average Watch Time',
    value: 'watches',
    legendText: 'How many seconds your video is viewed for'
  },
  {
    text: 'Engagement Rate by Outreach',
    value: 'new_engagement_rate',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by outreach'
  },
  {
    text: 'Play Rate (by Outreach)',
    value: 'new_engagement_rate_view',
    legendText: 'The total number of views divided by the outreach'
  },
  {
    text: 'Engagement Rate by Plays',
    value: 'interaction_rate_plays',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
  },
  {
    text: 'Engagement Rate by Reach',
    value: 'engagement_rate_reach',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by reach'
  },
  {
    text: 'Avg. Engagement Rate',
    value: 'engagement_rate_sd',
    legendText: 'The average sum of engagement rate on the last 30 posts'
  },
  {
    text: 'Median Engagement Rate',
    value: 'median_engagement_rate',
    legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
  },
  {
    text: 'Average Likes',
    value: 'avg_likes',
    legendText: 'Average likes over the last 30 posts'
  },
  {
    text: 'Average Comments',
    value: 'avg_comments',
    legendText: 'Average comments over the last 30 posts'
  },
  {
    text: 'Average Views',
    value: 'avg_views',
    legendText: 'Average views over the last 30 posts'
  },
  {
    text: 'Average Reels Plays',
    value: 'avg_reels_plays',
    legendText: 'Average plays over the last 30 posts'
  }
]

const tiktokAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Post URL',
    value: 'url',
    legendText: 'Post URL'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made'
  },
  {
    text: 'Total Play Time',
    value: 'plays',
    legendText: 'The all-time data for how many total hours, minutes, and seconds this piece of content was viewed.'
  },
  {
    text: 'Average Watch Time',
    value: 'watches',
    legendText: 'How many seconds your video is viewed for'
  },
  {
    text: 'Likes',
    value: 'likes',
    legendText: 'The number of times users have tapped the “like” button on a post.'
  },
  {
    text: 'Comments',
    value: 'comments',
    legendText: 'The number of written responses to a post.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a post.'
  },
  {
    text: 'Favourites',
    value: 'saved',
    legendText: 'The number of times users have saved a post to their “Saved” folder.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  },
  {
    text: 'Plays',
    value: 'views',
    legendText: 'The number of times users have viewed a post, including every looped view.'
  },
  {
    text: 'Total Viewers',
    value: 'reach',
    legendText: 'The total number of unique users who viewed the content'
  },
  {
    text: 'Impressions',
    value: 'impressions',
    legendText: 'Total number of times content have been shown to users'
  },
  {
    text: 'Average Views',
    value: 'avg_views',
    legendText: 'Average views over the last 30 posts'
  },
  {
    text: 'Average Likes',
    value: 'avg_likes',
    legendText: 'Average likes over the last 30 posts'
  },
  {
    text: 'Average Comments',
    value: 'avg_comments',
    legendText: 'Average comments over the last 30 posts'
  },
  {
    text: 'Average Saves',
    value: 'avg_saves',
    legendText: 'The average sum of saves on the last 30 posts'
  },
  {
    text: 'Average Shares',
    value: 'avg_shares',
    legendText: 'The average sum of shares on the last 30 posts'
  },
  {
    text: 'Engagement Rate by Outreach',
    value: 'new_engagement_rate',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by outreach'
  },
  {
    text: 'Play Rate (by Outreach)',
    value: 'new_engagement_rate_view',
    legendText: 'The total number of plays divided by the outreach'
  },
  {
    text: 'Engagement Rate by Plays',
    value: 'interaction_rate_plays',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by Plays'
  },
  {
    text: 'Engagement Rate by Total Viewers',
    value: 'eng_rate_total_viewers',
    legendText: 'The total number of interactions (users who liked, commented, saved or shared the post) divided by total viewers (reach)'
  },
  {
    text: 'Average Engagement Rate',
    value: 'engagement_rate_sd',
    legendText: 'The average sum of engagement rate on the last 30 posts'
  },
  {
    text: 'Median Engagement Rate',
    value: 'median_engagement_rate',
    legendText: 'The middle engagement rate amongst the sorted engagement rate of all the creator’ within same tier comparison.'
  },
  {
    text: 'Watched Full Video',
    value: 'watchedFullVideo',
    legendText: 'Watched Full Video'
  }
]

const youtubeAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Post URL',
    value: 'url',
    legendText: 'Post URL'
  },
  {
    text: 'Outreach',
    value: 'outreach'
  },
  {
    text: 'Total Views',
    value: 'views',
    legendText: 'Number of views'
  },
  {
    text: 'Likes',
    value: 'likes',
    legendText: 'Number of likes'
  },
  {
    text: 'Comments',
    value: 'comments',
    legendText: 'Number of comments'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  },
  {
    text: 'Average Views',
    value: 'avg_views',
    legendText: 'Average views over the last 30 posts'
  },
  {
    text: 'Average Likes',
    value: 'avg_likes',
    legendText: 'Average likes over the last 30 posts'
  },
  {
    text: 'Average Comments',
    value: 'avg_comments',
    legendText: 'Average comments over the last 30 posts'
  },
  {
    text: 'Engagement Rate by Interactions',
    value: 'new_engagement_rate',
    legendText: 'The total number of interactions divided by the subscriber numbers'
  },
  {
    text: 'Engagement Rate by Views',
    value: 'new_engagement_rate_view',
    legendText: 'The total number of views divided by the subscriber numbers'
  },
  {
    text: 'Average Engagement Rate',
    value: 'engagement_rate_sd',
    legendText: 'Average engagement for all advertorials and organic content'
  },
  {
    text: 'Median Engagement Rate',
    value: 'median_engagement_rate',
    legendText: 'Distribution by engagement rate for influencers having followers in the similar range/tier'
  }
]

const xhsAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made '
  },
  {
    text: 'Likes',
    value: 'like_count',
    legendText: `The total number of likes`
  },
  {
    text: 'Comments',
    value: 'comment_count',
    legendText: 'The number of comments.'
  },
  {
    text: 'Views',
    value: 'views',
    legendText: 'The number of views.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a story.'
  },
  {
    text: 'Bookmarks',
    value: 'bookmarks',
    legendText: 'The number of bookmarks.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  }
]
const fbAnalysisTableHeaders = [
  {
    text: 'Campaign',
    value: 'contents'
  },
  {
    text: 'Live Date',
    value: 'live_date',
    legendText: 'Live Date'
  },
  {
    text: 'Outreach',
    value: 'outreach',
    legendText: 'The number of followers the creator has at the time where the post was made '
  },
  {
    text: 'Likes',
    value: 'like_count',
    legendText: `The total number of likes`
  },
  {
    text: 'Comments',
    value: 'comment_count',
    legendText: 'The number of comments.'
  },
  {
    text: 'Views',
    value: 'views',
    legendText: 'The number of views.'
  },
  {
    text: 'Shares',
    value: 'shares',
    legendText: 'The number of times users have reposted / shared a story.'
  },
  {
    text: 'Bookmarks',
    value: 'bookmarks',
    legendText: 'The number of bookmarks.'
  },
  {
    text: 'Interactions',
    value: 'interactions',
    legendText: 'The sum of likes, comments, saves, shares'
  }
]
export default {
  postAnalysisTableHeaders,
  storyAnalysisTableHeaders,
  reelAnalysisTableHeaders,
  tiktokAnalysisTableHeaders,
  youtubeAnalysisTableHeaders,
  xhsAnalysisTableHeaders,
  fbAnalysisTableHeaders
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/StatisticsAnalysis/config.js